
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface DocumentTemplatesHeaderProps {
  onBack: () => void;
}

const DocumentTemplatesHeader = ({ onBack }: DocumentTemplatesHeaderProps) => {
  return (
    <div className="flex-shrink-0 p-6 border-b border-white/20 bg-white/10 backdrop-blur-sm">
      <div className="flex items-center gap-4">
        <Button 
          variant="outline" 
          onClick={onBack}
          className="sidebar-button-no-hover gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar aos Documentos
        </Button>
        <div>
          <h1 className="text-xl font-bold text-indigo-900">Modelos de Documentos</h1>
          <p className="text-sm text-purple-800 font-medium">
            Selecione um modelo para começar
          </p>
        </div>
      </div>
    </div>
  );
};

export default DocumentTemplatesHeader;
